import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources, defaultLanguage, fallbackLanguage, defaultNamespace, namespaces } from '@vn-propane/shared/i18n';

// Get stored language or use default
const getStoredLanguage = (): string => {
  if (typeof window === 'undefined') return defaultLanguage;
  return localStorage.getItem('i18n_language') || defaultLanguage;
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getStoredLanguage(),
    fallbackLng: fallbackLanguage,
    defaultNS: defaultNamespace,
    ns: namespaces as unknown as string[],
    interpolation: {
      escapeValue: false,
    },
    debug: import.meta.env.DEV,
  });

export default i18n;
